import React, {useEffect, useState} from 'react';
import {CustomDivider, StyledPopUp} from "../../../../../shared";
import {PricePopUpProps} from "../../../models";
import {Button, Divider, Flex, List} from "antd";
import PricePopUpCard from "./PricePopUPCard";

const PricePopUp = ({open,onCansel,product,onConfirm} :PricePopUpProps) => {
    const [data, setData] = useState<any[]>([])
    const [activeId, setActiveId] = useState<any>("")
    useEffect(() => {
        setData(product?.map((item:any) => ({
            ...item,
            isActive:false,
        })).sort((a:any, b:any) => a.pricingMethodId - b.pricingMethodId))
    }, [product]);
    const onActive = (id:string) => {
        setActiveId(id)
        setData(data.map((item:any) => ({
            ...item,
            isActive:id === item.id
        })))
    }
    return (
        <StyledPopUp
        open={open}
        onCancel={onCansel}
        title={
            <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>قیمت</span>
            <span style={{ fontSize: "12px", color: "gray", marginTop: "4px" }}>
                مبلغ اجاره نهایی پس از تعیین بازه زمانی، توسط سیستم مشخص خواهد شد.
.
            </span>
            </div>
  }

        width={"100%"}
        footer={null}
        closeIcon={false}
        transitionName={''}
        >
            <Flex vertical gap={"small"} style={{maxHeight: "400px", overflowX: "hidden" ,overflowY: "auto",marginTop:"30px"}}>
               <List
                   grid={{
                       gutter: 16,
                       xs: 1,
                       sm: 1,
                       md: 1,
                       lg: 1,
                       xl: 1,
                       xxl: 1,
                   }}
                   dataSource={data}
                   renderItem={(item) => (
                       <List.Item>
                           <PricePopUpCard id={item.id} onActive={(id:string) =>onActive(id)} price={item.price} rentType={item.title} isActive={item.isActive}/>
                           <CustomDivider/>
                       </List.Item>
                   )}
               />
               <Button type={"primary"} block size={"large"} onClick={() => onConfirm(activeId)}>متوجه شدم</Button>
           </Flex>
        </StyledPopUp>
    );
};

export default PricePopUp;
